import { CLAUDE_MODEL_CATALOG } from '../claudeModelCatalog';
import { ModelCombobox } from './ModelCombobox';

/**
 * Thin `ModelCombobox` wrapper over `CLAUDE_MODEL_CATALOG` (spec 160 R2) —
 * see `ModelCombobox.tsx` for the shared search/grouping/free-text behavior.
 */
export function ClaudeModelCombobox({
  value,
  onChange,
  id,
  disabled = false,
  autoFocus,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}: {
  value: string;
  onChange: (model: string) => void;
  id?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  'aria-invalid'?: boolean;
  'aria-describedby'?: string;
}) {
  return (
    <ModelCombobox
      catalog={CLAUDE_MODEL_CATALOG}
      value={value}
      onChange={onChange}
      id={id}
      placeholder="claude-opus-4-8"
      disabled={disabled}
      autoFocus={autoFocus}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
    />
  );
}
